import { Component } from '@angular/core';
import { Router } from '@angular/router';
import {
    BaseCellRendererComponent,
    TapestrySidenavService
} from '@predictiveindex/tapestry';
import { FeatureFlags, FeatureFlagsService } from '../../../../system-services';

@Component({
    selector: 'oi-action-menu-renderer',
    template: `<a class="clickable" (click)="openFolder()">{{
        params.name
    }}</a>`,
    standalone: false
})
export class OIOpenFolderRendererComponent extends BaseCellRendererComponent {
    constructor(
        public sideNav: TapestrySidenavService,
        private router: Router,
        private featureFlags: FeatureFlagsService
    ) {
        super();
    }

    openFolder() {
        const navigationRoute = this.featureFlags.getByFlag(
            FeatureFlags.enableSellerExperience
        )
            ? `/pi/seller-experience/folders/folder-details/${this.params.folderId}`
            : `/pi/oi/folder/${this.params.folderId}`;

        /**
         * Since this is navigating by **absolute** routing, we'll need the /pi in here.
         * Otherwise, this routes to SPA instead of back into the platform app. While SPA
         * should re-route back to platform if the company is PI2, for the case of third-party
         * users with Legacy companies, this re-route does NOT occur. Hence, forcing the /pi.
         */
        void this.router.navigateByUrl(navigationRoute);
        this.sideNav.close();
    }
}
